import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import ca from './locales/ca.json';
import pt from './locales/pt.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import sr from './locales/sr.json';
import ru from './locales/ru.json';
import it from './locales/it.json';
import sv from './locales/sv.json';
import da from './locales/da.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import ko from './locales/ko.json';
import ja from './locales/ja.json';

export const languages = [
  { code: 'en', name: 'English', displayCode: 'EN' },
  { code: 'es', name: 'Español', displayCode: 'ES' },
  { code: 'ca', name: 'Català', displayCode: 'CA' },
  { code: 'pt', name: 'Português', displayCode: 'PT' },
  { code: 'fr', name: 'Français', displayCode: 'FR' },
  { code: 'it', name: 'Italiano', displayCode: 'IT' },
  { code: 'de', name: 'Deutsch', displayCode: 'DE' },
  { code: 'sv', name: 'Svenska', displayCode: 'SV' },
  { code: 'da', name: 'Dansk', displayCode: 'DA' },
  { code: 'nl', name: 'Nederlands', displayCode: 'NL' },
  { code: 'pl', name: 'Polski', displayCode: 'PL' },
  { code: 'sr', name: 'Српски', displayCode: 'RS' },
  { code: 'ru', name: 'Русский', displayCode: 'RU' },
  { code: 'ar', name: 'العربية', displayCode: 'AR' },
  { code: 'zh', name: '中文', displayCode: 'ZH' },
  { code: 'ko', name: '한국어', displayCode: 'KO' },
  { code: 'ja', name: '日本語', displayCode: 'JA' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      fr: { translation: fr },
      ca: { translation: ca },
      pt: { translation: pt },
      nl: { translation: nl },
      pl: { translation: pl },
      sr: { translation: sr },
      ru: { translation: ru },
      it: { translation: it },
      sv: { translation: sv },
      da: { translation: da },
      ar: { translation: ar },
      zh: { translation: zh },
      ko: { translation: ko },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
